import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './styles/globals.css';
import { App } from './App.js';
import { configureAmplifyFromEnv, getIdToken } from './lib/amplify.js';
import { configureApiClient } from './lib/api-client.js';
import { signOut } from 'aws-amplify/auth';
import { AuthProvider } from './features/auth/auth-context.js';
import { ToastProvider } from './components/ui/Toast.js';

configureAmplifyFromEnv();

configureApiClient({
  baseUrl: import.meta.env.VITE_API_URL ?? '',
  getToken: () => getIdToken(),
  onUnauthorized: () => {
    void signOut().finally(() => {
      if (typeof window !== 'undefined') {
        window.location.replace('/login');
      }
    });
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root not found');
}

createRoot(container).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
